import classNames from 'classnames';
// import PropTypes from 'prop-types';
import Trigger, { TriggerProps } from 'rc-trigger';
import React, { ReactElement, ReactNode, useState, useMemo, useRef, useCallback, useEffect } from 'react';
// import omit from 'omit.js';
import {cssUtil, getClsPrefix, WebUI, getNid, prefix} from "../../wui-core/src/index";
import Icon from '../../wui-icon/src/index';
import placements from './placement';
import { DropDownProps, Align } from './iDropdown';
import { MenuProps } from '../../wui-menu/src/iMenu';
import Menu from '../../wui-menu/src';
import { WithConfigConsumer } from '../../wui-provider/src/context';

const menuClsPrefix = getClsPrefix("menu");
export const DropdownDefaultProps: DropDownProps = {
    children: <span />,
    disabled: false,
    trigger: ['hover'],
    showAction: [],
    hideAction: [],
    minOverlayWidthMatchTrigger: true,
    overlayClassName: '',
    overlayStyle: {},
    overlay: '暂无数据',
    placement: 'bottomLeft',
    defaultVisible: false,
    overlayMaxHeight: false,
    destroyPopupOnHide: false,
    transitionName: 'slide-up',
};

const rtlPlacementMap: Record<string, string> = {
    topLeft: 'bottomRight',
    topRight: 'bottomLeft',
    bottomLeft: 'topRight',
    bottomRight: 'topLeft',
}

const defaultPopupOffset = [0, 5];

interface TriggerRef extends React.Component<TriggerProps, any>{
	getPopupDomNode: () => React.ReactNode & HTMLElement;
	getRootDomNode: () => React.ReactNode & HTMLElement;
}

const Dropdownf = (props: DropDownProps) => {
    const {
        clsPrefix,
        children = <span />,
        placement = 'bottomLeft',
        // animation,
        // align,
        getDocument,
        showAction = [],
        hideAction = [],
        overlayClassName = '',
        overlayStyle = {},
        trigger = ['hover'],
        disabled = false,
        delay,
        delayShow,
        delayHide,
        destroyPopupOnHide = false,
        dir,
        getPopupContainer,
        overlay = '暂无数据',
        minOverlayWidthMatchTrigger = true,
        overlayMaxHeight = false,
        visible: controlledVisible,
        defaultVisible = false,
        onVisibleChange,
        transitionName,
        ...otherProps
    } = props;

    // 内联实现受控/非受控状态逻辑，减少依赖
    const [innerVisible, setInnerVisible] = useState<boolean>(() => {
        if ('visible' in props) {
            return controlledVisible ?? false;
        }
        return defaultVisible;
    });

    // 同步受控值的变化
    useEffect(() => {
        if (('visible' in props) && controlledVisible !== innerVisible && typeof controlledVisible === 'boolean') {
            setInnerVisible(controlledVisible);
        }
    }, [controlledVisible, innerVisible]);


    const [popupAlign, setPopupAlign] = useState<Align | null>(null);
    const _placement = dir === 'rtl' ? rtlPlacementMap[placement as string] : placement;
    const triggerRef = useRef<TriggerRef | null>(null);
    let adapterNid = getNid(props);

    const getPopupDomNode = () => {
        return triggerRef?.current?.getPopupDomNode();
    }

    const getRootDomNode = () => {
        return triggerRef?.current?.getRootDomNode();
    }

    const { childs, overlayMenu } = useMemo(() => {
        let overlayNode: ReactElement | null = null;
        let _children: ReactNode = children;
	    if (Array.isArray(children)) {
	        const childs: ReactNode[] = children.reduce((preChilds, child) => {
	            if (!overlayNode && child?.props?.clsPrefix === `${prefix}-menu`) {
	                overlayNode = child;
	                return preChilds
	            }
	            if (child) {
	                return [...preChilds, child];
	            }
	            return preChilds
	        }, [])
            _children = childs[0];
	    }
        if (typeof overlay === 'function') {
	        overlayNode = overlay();
	    } else if (React.isValidElement(overlay)) {
		  	overlayNode = overlay;
	    } else if (typeof overlay === 'string') {
	        overlayNode = <span>{overlay}</span>;
	    } else if (typeof overlay === 'object' && (overlay as MenuProps)?.items) {
	        overlayNode = <Menu {...overlay}></Menu>
	    }
	    return {childs: _children, overlayMenu: overlayNode}
    }, [children, overlay]);

    const getpopupAlign = () => {
	    const {dir, placement = dir === 'rtl' ? 'bottomRight' : 'bottomLeft'} = props;
	    // let popupAlign = null;
	    // if (overlayMaxHeight) {
	    //     popupAlign = typeof placement === 'object' ? {...placements.bottomLeftNoAdjustY, ...placement} : {...placements.bottomLeftNoAdjustY, ...placements[`${placement}NoAdjustY`]};
	    // } else {
	    //     popupAlign = typeof placement === 'object' ? {...placements.bottomLeft, ...placement} : {...placements.bottomLeft, ...placements[placement]};
	    // }
	    let placementFinal = dir === 'rtl' && placement === "bottomLeft" ? 'bottomRight' : placement;
	    return typeof placementFinal === 'object' ? {...(dir === 'rtl' ? placements.bottomRight : placements.bottomLeft), ...placementFinal} : {...(dir === 'rtl' ? placements.bottomRight : placements.bottomLeft), ...placements[placementFinal]};
    }

    const afterVisibleChange = useCallback((visible: boolean) => {
        const {overlayMaxHeight, minOverlayWidthMatchTrigger, overlayStyle = {}, dropdownStyle, dir, domid} = props;
	    if (visible) {
	        // 此处调整为先计算popupAlign，后在下一次渲染时集中更新popupStyles
	        // 同时解决getPopupDomNode返回为null的问题
	        // 原因: 触发此方法时，cssMotion中的visible还未更新，故destroy后visible变为true时，获取到的是null
	        let align = getpopupAlign();
	        requestAnimationFrame(() => {
	            const overlayNode = getPopupDomNode() as HTMLElement;
	            const rootNode = getRootDomNode() as HTMLElement;
	            // 添加空值检查，避免测试环境中DOM节点未准备好
	            if (!rootNode || !overlayNode) {
	                return;
	            }
	            const matchNode = domid ? document.querySelector(`div[data-domid = "${domid}"]`) as HTMLElement : null;
	            const rootRect = rootNode.getBoundingClientRect();
	            const rootWidth = rootRect.width;
	            let matchWidth = rootWidth;
	            const popupStyles: Record<string, string> = {};
	            // align设置 x 轴以左边开始位移，则 x 轴位移需要加上左边按钮宽度。其他以用户设置的align(placement)为准
	            if (matchNode && (dir === 'rtl' ? align.points[0].indexOf('r') > 0 : align.points[0].indexOf('l') > 0)) {
	                matchWidth = matchNode.offsetWidth;
	                const offsetX = rootWidth - matchWidth;
	                align = dir === 'rtl' ? {...align, offset: [align!.offset![0] - offsetX, align!.offset![1]]} : {...align, offset: [offsetX + align!.offset![0], align!.offset![1]]};
	            }
	            if (popupAlign || JSON.stringify(align) !== JSON.stringify(popupAlign)) {
	                setPopupAlign({...align});
	            }
	            // style优先级：overlayStyle > minOverlayWidthMatchTrigger
	            if (minOverlayWidthMatchTrigger && matchWidth > overlayNode.offsetWidth && !overlayStyle?.minWidth) {
	                popupStyles['min-width'] = `${matchWidth}px`
	            }
	            if (dropdownStyle) {
	                let styleObj = {
	                    minWidth: matchWidth
	                }
	                Object.assign(popupStyles, dropdownStyle(styleObj))
	            }
	            // style优先级：overlayStyle > overlayMaxHeight
	            if (overlayMaxHeight && !overlayStyle?.maxHeight) {
	                if (typeof overlayMaxHeight === 'number') {
	                    popupStyles['max-height'] = `${overlayMaxHeight}px`;
	                    popupStyles.overflow = 'auto';
	                } else {
	                    const maxHeight = Math.max(document.body.clientHeight - rootRect.bottom, rootRect.top) - 20;
	                    popupStyles['max-height'] = `${maxHeight}px`;
	                    popupStyles.overflow = 'auto';
	                }
	            }
	            Object.keys(popupStyles).forEach(key => {
	                overlayNode.style[key as any] = `${popupStyles[key]}`
	            })
	        })
	    }
    }, [overlayMaxHeight, minOverlayWidthMatchTrigger, overlayStyle, props.dropdownStyle, props.matchNode, dir]);

    const handleVisibleChange = useCallback((newVisible: boolean) => {
        if (disabled) return;
        if (!('visible' in props)) {
            setInnerVisible(newVisible);
        }
        onVisibleChange?.(newVisible);
    }, [disabled, onVisibleChange]);

    const addPopupOffset = (elements: React.ReactElement[]) => {
	    if (Array.isArray(elements)) {
	        return elements.map(ele=>{
	            if (ele?.props?.clsPrefix === menuClsPrefix) {
	                return React.cloneElement(ele, { popupOffset: defaultPopupOffset, });
	            }
	            return ele
	        })
	    } else {
	        return elements
	    }
    };

    const getPopupContainerDom = (dom: HTMLElement) => {
	    if (typeof getPopupContainer === 'function') {
	        return getPopupContainer(dom)
	    } else {
	        return cssUtil.parentsUntil(dom);
	    }
    }

    const onClick = useCallback((e: React.MouseEvent<HTMLUListElement>) => {
        // let overlayNode = typeof overlay === 'function' ? overlay() : overlayMenu ? overlayMenu : overlay;
        const overlayProps = (overlayMenu && React.isValidElement(overlayMenu) ? overlayMenu.props : {multiple: undefined}) as Partial<MenuProps>;
        const { multiple } = overlayProps;
        // do no call onVisibleChange, if you need click to hide, use onClick and control visible
        // menu菜单multiple模式下点击不收起弹框
        if (!('visible' in props) && !multiple) {
            setInnerVisible(false);
        }
        if (overlayProps.onClick) {
            overlayProps.onClick(e as any);
        }
    }, [overlayMenu]);

    const popupElement = useMemo(() => {
        if (!overlayMenu) {
            return <span>暂无数据</span>;
        }

        let overlayNode = overlayMenu as React.ReactElement;

        // 确保 overlayNode 是有效的 React 元素
        if (typeof overlayNode === 'string') {
            overlayNode = <span>{overlayNode}</span>;
        } else if (!React.isValidElement(overlayNode)) {
            return <span>暂无数据</span>;
        }

        overlayNode = React.Children.only(overlayNode);

        /** 外部传入不确定类型，需要any类型 */
        if ((overlayNode as (React.ReactElement | any)).type?.defaultProps?.clsPrefix !== menuClsPrefix) {
            return React.cloneElement(overlayNode, {
                className: classNames({[`${clsPrefix}-menu-match-trigger`]: minOverlayWidthMatchTrigger}, overlayNode.props.className),
                children: addPopupOffset(overlayNode.props.children),
                onClick: onClick
            });
        }
        const { subMenuCloseDelay, subMenuOpenDelay } = overlayNode.props;
        return React.cloneElement(overlayNode, {
            mode: 'dropdown',
            onClick: onClick,
            selectIcon: <Icon type="uf-correct-2"/>,
            className: classNames({[`${clsPrefix}-menu-match-trigger`]: minOverlayWidthMatchTrigger}, overlayNode.props.className),
            subMenuCloseDelay: subMenuCloseDelay ?? (delayHide && delayHide / 1000) ?? (delay && delay / 1000),
            subMenuOpenDelay: subMenuOpenDelay ?? (delayShow && delayShow / 1000) ?? (delay && delay / 1000),
            popupOffset: defaultPopupOffset,
        });
    }, [overlayMenu, clsPrefix, minOverlayWidthMatchTrigger, delayHide, delayShow, delay, onClick]);

    const newVisible = 'visible' in props ? controlledVisible : innerVisible;

    return (<Trigger
        {...otherProps}
        prefixCls={clsPrefix}
        ref={triggerRef}
        popupClassName={overlayClassName}
        popupStyle={overlayStyle}
        builtinPlacements={placements}
        action={trigger}
        showAction={showAction}
        hideAction={hideAction}
        popupAlign={popupAlign || placements[_placement as string]}
        popupTransitionName={transitionName}
        // popupAnimation={animation} // 取消使用animation 全部使用transitionName
        popupVisible={disabled ? false : newVisible}
        afterPopupVisibleChange={afterVisibleChange}
        popup={popupElement}
        // stretch='minWidth'
        onPopupVisibleChange={handleVisibleChange}
        getPopupContainer={getPopupContainerDom}
        getDocument={getDocument}
        mouseEnterDelay={(delayShow && delayShow / 1000) ?? (delay && delay / 1000)}
        mouseLeaveDelay={(delayHide && delayHide / 1000) ?? (delay && delay / 1000)}
        autoDestroy={destroyPopupOnHide}
        {...adapterNid}
    >
        {
            props.uirunmode === "design" && props.uitype !== "Dropdown.Button"
                ? <span className={`${clsPrefix}-wrap`} {...adapterNid} > {childs} </span>
                : React.isValidElement(childs) ? React.cloneElement(childs as React.ReactElement, {
                    className: classNames(`${clsPrefix}-trigger`, childs?.props.className),
                }) : childs as any
        }
    </Trigger>)
}

const dropdownMemo = React.memo(Dropdownf);

export default WithConfigConsumer()(WebUI({ name: "dropdown" })(dropdownMemo));
